import React, { memo } from "react";
import useDevicesPerDayLinearChart from "./index.hooks";
import { ResponsiveLine } from "@nivo/line";
import { AppPaper } from "../index";
import { Typography } from "@material-ui/core";

type DevicesPerDayLinearChartProps = {};

const DevicesPerDayLinearChart = ({}: DevicesPerDayLinearChartProps) => {
  const { styles, classes, atomicStyles, data } = useDevicesPerDayLinearChart();

  return (
    <AppPaper className={styles.chartPaper}>
      <Typography>Devices Per Day Chart</Typography>
      <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 110, bottom: 65, left: 60 }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "date",
          legendOffset: 36,
          legendPosition: "middle",
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "count",
          legendOffset: -40,
          legendPosition: "middle",
        }}
        pointSize={10}
        pointColor={{ theme: "background" }}
        pointBorderWidth={2}
        pointBorderColor={{ from: "serieColor" }}
        pointLabelYOffset={-12}
        useMesh={true}
      />
    </AppPaper>
  );
};

export default memo(DevicesPerDayLinearChart);
